// extracted by mini-css-extract-plugin
export default {"addToCartControl":"K3-z","giftCard":"L3-z","btnContainer":"M3-z","cartButton":"N3-z","disabled":"O3-z","stockMessage":"P3-z"};